// src/lib/capture/statusSummary.ts — CBAM mobile capture (Phase 1)
//
// Thin client wrapper over the capture_status_summary RPC. Returns a
// processing-status summary for a batch of sources so the capture/review UI can
// poll progress and surface derived counts.

import { supabase } from "@/integrations/supabase/client";

export interface CaptureStatus {
  source_id: string;
  status: string;
  status_detail: string | null;
  action_item_count: number | null;
  entity_count: number | null;
  word_count: number | null;
}

/**
 * Fetch status summaries for the given source ids. Returns an empty array when
 * no ids are supplied. Throws if the RPC returns an error.
 */
export async function getCaptureStatus(
  sourceIds: string[],
): Promise<CaptureStatus[]> {
  if (sourceIds.length === 0) {
    return [];
  }

  // Cast rpc name: capture_status_summary is not in the generated types yet.
  const { data, error } = await (supabase.rpc as any)("capture_status_summary", {
    _source_ids: sourceIds,
  });

  if (error) {
    throw new Error(`getCaptureStatus failed: ${error.message}`);
  }

  return (data ?? []) as CaptureStatus[];
}
